export default {
  testimonials: [],
};
